<template lang="pug">
  #calendar.container-fluid
    b-row
      b-col.mb-2.px-0.px-md-2(cols="12")
        .d-flex.justify-content-around.align-items-end
          .col-8.px-0
            p.mb-0.small.light-text Ver
            b-form-select.p-0(
              v-model="subjectSelected"
              :options="subjectOptions"
              data-style="options"
              @change="updateCharts"
            )
          //.flex-column.px-2.text-center.align-items-center.control.expand#tooltip-1.desktop(@click="downloadData()")
            i.fas.fa-download
            p.mb-1.smaller {{ downloadStatus ? 'Descargando...' : 'Descarga'}}
            b-tooltip.desktop(target="tooltip-1" triggers="hover") Descarga los datos en formato csv
          .mobile
            .flex-column.px-2.text-center.align-items-center.control.expand(@click="collapse()")
              i.fas.fa-compress
              p.mb-1.smaller {{ expand ? 'Colapsa' : 'Expande'}}
          .desktop
            .flex-column.px-2.text-center.align-items-center.control.expand#tooltip-2(@click="collapse()")
              i.fas.fa-compress
              p.mb-1.smaller {{ expand ? 'Colapsa' : 'Expande'}}
            b-tooltip(target="tooltip-2" triggers="hover") Explora las publicaciones

      .desktop.col-12.px-0
        b-col.d-flex.align-items-end.flex-wrap.px-0
          .flex-column.px-2.mt-2.text-center.align-items-center.theme-label(v-for="(theme, i) in Object.keys(themeColors)")
            p.mb-1.smaller.light-text {{ theme }}
            .box.mb-1(v-bind:style="{ backgroundColor: themeColors[theme]}")
          //.flex-column.px-2.text-center.align-items-center.control.expand(@click="collapse()")
            i.fas.fa-compress
            p.mb-0.small {{ expand ? 'Colapsa' : 'Expande'}}
    .mobile
      //(v-if="isMobile")
      .row.mt-3
        b-col.pl-0(cols="6")
          .theme.d-flex(v-for="(theme, i) in Object.keys(themeColors).slice(0, Object.keys(themeColors).length /2)")
            .box(v-bind:style="{ backgroundColor: themeColors[theme]}")
            p.mb-1.smaller.light-text {{ theme }}
        b-col.pr-0(cols="6")
          .theme.d-flex(v-for="(theme, i) in Object.keys(themeColors).slice(Object.keys(themeColors).length /2)")
            .box(v-bind:style="{ backgroundColor: themeColors[theme]}")
            p.mb-1.smaller.light-text {{ theme }}

    transition-group(name="fade")
      b-row.my-5(v-if="!expand && journalistCategories[optionsCode[subjectSelected]].length === 0" key="notfound")
        b-col.mt-3.px-0(cols="12")
          h5.text-center No hay publicaciones con esa información
      b-row.my-5(v-if="!expand" key="bar")
        b-col#barscol.mt-3.px-0(cols="12")
          #bars
      b-row#heatmap.mt-3.mb-5.my-md-5(v-if="expand" key="heatmap")
        b-col.desktop(cols="12")
          //  v-if="!isMobile"
          .d-flex.flex-row.justify-content-center.weeks.my-2(v-for="week in totalWeeks" v-bind:key="week" :data-week="week")
            .dateborder
              p.month
            .dateborder
              p.date Semana del
                br
                span {{ (new Date(week).toLocaleDateString('es-mx', {dateStyle: "medium"})) }}
            .borders
              .blocks(@contextmenu.prevent="$refs.menu.open")
            .borders
              .blocks(@contextmenu.prevent="$refs.menu.open")
            .borders
              .blocks(@contextmenu.prevent="$refs.menu.open")
            .borders
              .blocks(@contextmenu.prevent="$refs.menu.open")
            .borders
              .blocks(@contextmenu.prevent="$refs.menu.open")
            .borders
              .blocks(@contextmenu.prevent="$refs.menu.open")
            .borders
              .blocks(@contextmenu.prevent="$refs.menu.open")
        b-col.mobile(cols="12")
          .row.d-flex.justify-content-center.allmonths.my-2(v-for="month in totalMonths" v-bind:key="month" :data-month="month")
            .col-12.px-0.mb-2.mt-4
              p.month
                span {{month}}
                //span {{months}}
                //span {{ months[Number.parseInt(month.substr(1,3)) - 1] + '. ' + month.substr(-4)}}

            .col-12.pl-3.pr-0
              .flex-row.d-flex.flex-wrap
                .mobile-blocks.mr-2.mb-2(v-for="(publication, index) in publishedByMonth[month]" v-bind:key="index" @click="selectedPublication = publication; goToPublication();")

    vue-context(ref='menu')
      li
        a(@click.prevent='goToPublication()') Abrir en la misma pestaña
      li
        a(@click.prevent='goToPublication("tab")') Abrir en una pestaña nueva

</template>
<script>
import * as d3 from "d3";
import VueContext from 'vue-context';

export default {
  name: "Calendar",
  components: {
    VueContext
  },
  data() {
    return {
      subjectSelected: "Tema",
      subjectOptions: [
        "Tema",
        "Partido político Presidente municipal",
        "Estado",
        "Plataforma",
      ],
      optionsCode: {
        "Tema": "themes",
        "Partido político Presidente municipal": "politicalParty",
        "Estado": "states",
        "Plataforma": "platforms",
      },
      themeColors: {
        "Justicia y Derechos Humanos": " #000",
        "Salud": " #1a6ba8",
        "Política": "#fd7c30",
        "Noticias": "#fdcb46",
        "Religión": "#fc0f1c",
        "Cultura / Sociedad": "#fb82c5",
        "Policiaca": "#973a4e",
        "Deportes": "#42cb1f",
        "Economía / Laboral": "#338d34",
        "Educación": "#6d3a9a",
        "Medio Ambiente": "#2daffc",
      },
      journalistCategories: {
        themes: [],
        platforms: [],
        states: [],
        politicalParty: [],
      },
      publishedWeeks: {},
      totalWeeks: [],
      expand: true,
      publishedByMonth: [],
      totalMonths: [],
      downloadStatus: false,
      months: [
        "Ene",
        "Feb",
        "Mar",
        "Abr",
        "May",
        "Jun",
        "Jul",
        "Ago",
        "Sep",
        "Oct",
        "Nov",
        "Dic",
      ]
    }
  },
  computed: {
    urlName() {
      return this.selectedJournalist.Nombre.split(" ").join("-");
    },
    isMobile() {
      return this.$store.state.isMobile;
    },
    selectedJournalist: {
      get() {
        return this.$store.state.selectedJournalist;
      },
      set(newValue) {
        this.$store.state.selectedJournalist = newValue;
      }
    },
    selectedPublication: {
      get() {
        return this.$store.state.selectedPublication;
      },
      set(newValue) {
        this.$store.state.selectedPublication = newValue;
      }
    },
    journalistPublications() {
      return this.$store.state.journalistPublications;
    }
  },
  watch: {
    journalistPublications: function() { this.update() },
  },
  methods: {
    goToPublication(destination) {
      //this.selectedPublication = publication;
      window.scrollTo(0,0);
      if (destination === "tab") {
        let routeData = this.$router.resolve({ path: `/publicacion/${this.selectedPublication.index}/periodista/${this.urlName}` });
        window.open(routeData.href, '_blank');
      } else {
        this.$router.push({ path: `/publicacion/${this.selectedPublication.index}/periodista/${this.urlName}` });
      }
    },
    collapse() {
      this.expand = !this.expand;
      setTimeout(()=> {
        if (this.expand) {
          this.drawHeatmap(this.subjectSelected);
          this.drawMobileHeatMap(this.subjectSelected);
        } else this.drawBars(this.subjectSelected);
      }, 100)
    },
    getJournalistOptions() {
      let totalThemes = new Set();
      let parties = new Set();
      let states = new Set();
      let platform = new Set();
      this.journalistPublications.forEach((el, index) => {
        totalThemes.add(...el["Tema"]);
        platform.add(...el["Plataforma"]);
        if (el["Partido político Presidente municipal"] !== "") parties.add(el["Partido político Presidente municipal"]);
        if (el["Estado"] !== "") states.add(el["Estado"]);
        el.index = index;
      });
      this.journalistCategories.platforms = [...platform].filter(t => t != "");
      this.journalistCategories.themes = [...totalThemes].filter(t => t != "");
      this.journalistCategories.states = [...states];
      this.journalistCategories.politicalParty = [...parties];
    },
    colorSchemes(selection) {
      if (selection === "Tema") {
        this.themeColors = {
          "Justicia y Derechos Humanos": " #000",
          "Salud": " #1a6ba8",
          "Política": "#fd7c30",
          "Noticias": "#fdcb46",
          "Religión": "#fc0f1c",
          "Cultura / Sociedad": "#fb82c5",
          "Policiaca": "#973a4e",
          "Deportes": "#42cb1f",
          "Economía / Laboral": "#338d34",
          "Educación": "#6d3a9a",
          "Medio Ambiente": "#2daffc",
        };
      } else {
        const colors = d3.schemeCategory10;
        this.themeColors = {};
        this.journalistCategories[this.optionsCode[selection]].forEach((el, index) => {
          this.themeColors[el] = colors[index] ? colors[index] : colors[index % colors.length];
        });
      }
    },
    updateCharts() {
      this.colorSchemes(this.subjectSelected);
      if (this.expand) {
        this.drawHeatmap(this.subjectSelected);
        this.drawMobileHeatMap(this.subjectSelected);
      }
      else this.drawBars(this.subjectSelected);
    },
    drawBars(selection) {
      const vm = this,
        bindTo = 'bars',
        width = d3.select('#barscol').node().getBoundingClientRect().width,
        height = d3.select('#barscol').node().getBoundingClientRect().height,
        chartCategories = this.journalistCategories[this.optionsCode[selection]];
      let _data;

      /*if (selection === "Tema" || selection === "Plataforma") {
        _data = d3.nest()
          .key(d => d)
          .rollup(d => vm.journalistPublications.filter(o => o[selection].indexOf(d[0]) > -1).length)
          .entries(chartCategories);
      } else {*/
        _data = d3.nest()
          .key(d => d)
          .rollup(d => vm.journalistPublications.filter(o => o[selection] === d[0]).length)
          .entries(chartCategories);
      //}
      const x = "key",
        y = "value",
        padding = 0.1;

      d3.select('#' + bindTo + " svg").remove();

      const svg
        = d3.select('#' + bindTo)
            .append("svg")
            .attr("width", width)
            .attr("height", height);

      const g
        = svg.append("g");

      const xScale = d3.scaleBand()
        .domain(chartCategories)
        .range([0, width])
        .padding(padding);

      const yScale = d3.scaleLinear()
        .domain([0, d3.max(_data, d => Number(d[y]))])
        .range([height, 0]);

      svg.append("g")
        .call(d3.axisLeft(yScale).tickSize(0))
        .select(".domain").remove();

      svg.append("g")
        .attr("transform", "translate(0," + (height) + ")")
        .call(d3.axisBottom(xScale).tickSize(0))
        .select(".domain").remove();
      svg.selectAll(".tick").remove();

      g.selectAll(".bar")
        .data(_data)
        .enter()
        .append("rect")
          .attr("class", "bar")
          .attr("x", d => xScale(d[x]))
          .attr("y", d => yScale(d[y]))
          .attr("width", d => xScale.bandwidth() > 350 ? 350 : xScale.bandwidth())
          .attr("height", d => height - yScale(d[y]))
          .style("fill", d => vm.themeColors[d  ["key"]] ? vm.themeColors[d["key"]] : "#e8ebeb");
    },
    getPublishedMonths() {
      this.publishedByMonth = d3.nest()
        .key(d => d.month)
        .object(this.journalistPublications);
      this.totalMonths = Object.keys(this.publishedByMonth);
    },
    getPublishedWeeks() {
      this.publishedWeeks = d3.nest()
        .key(d => d.weekStart)
        .key(d => d.dayNumber)
        .object(this.journalistPublications);
      this.totalWeeks = Object.keys(this.publishedWeeks).filter(el => el != "null");
      this.totalWeeks.forEach(week => {
        const year = new Date(week).getFullYear(),
              month = new Date(week).getMonth(),
              monthFirst = (new Date(year, month)).toISOString(),
              firstWeek = this.getFirstWeekDay(monthFirst),
              lastWeek = this.getFirstWeekDay((new Date(year, month + 1,0)).toISOString());
        //get all weeks of each published month
        for (let i = 0; i <= 5; i++) {
          let middleWeek = this.addDays(firstWeek, 7 * i);
          if (middleWeek != week && this.totalWeeks.indexOf(middleWeek) < 0 && new Date(middleWeek) <= new Date(lastWeek)) {
            this.totalWeeks.push(middleWeek);
            this.publishedWeeks[middleWeek] = {};
          }
        }
      });
      this.totalWeeks.sort((a,b) => new Date(b) - new Date(a));
    },
    drawMobileHeatMap(selection) {
      const months = document.querySelectorAll("div.allmonths");
      months.forEach(m => {
        const monthDate = m.dataset.month;
        m.querySelectorAll(".mobile-blocks").forEach((block, i) => {
          let gradient = "linear-gradient(45deg, ";
          const publication = this.publishedByMonth[monthDate][i];
          // const totalColors = publication[selection].length;
          gradient = publication[selection] ? this.themeColors[publication[selection]] : "#ededed";
          block.style.background = gradient;
        })
      });
    },
    drawHeatmap(selection) {
      const weeks = document.querySelectorAll("div.weeks");
      weeks.forEach((w, j) => {
        const weekDate = w.dataset.week;
        const lastWeek = this.monthChecker(weekDate, +7);
        const borderStyle = "2px solid";

        w.querySelectorAll("div.dateborder").forEach((d, k) => {
          const weekData = Object.keys(this.publishedWeeks[weekDate]).length > 0;
          if (lastWeek) d.style.borderTop = borderStyle;
          else d.style.borderTop = "none";
          if (lastWeek && k == 0) d.querySelector("p.month").textContent = ((new Date(weekDate)).toLocaleString('es-mx', { month: 'short' }).substr(0,3));
          else if (!lastWeek && k == 0) d.querySelector("p.month").textContent = "";
        });

        // draw blocks
        w.querySelectorAll("div.blocks").forEach((b, i) => {
          if (!this.publishedWeeks[weekDate][i])
            b.classList.add("empty");
          else {
            b.classList.remove("empty");
            let gradient = "linear-gradient(45deg, ";
            let blockThemes = new Set();

            /*if (selection === "Tema" || selection === "Plataforma") {
              this.publishedWeeks[weekDate][i].forEach(el => {
                blockThemes.add(...el[selection])
              });
            } else {*/
              this.publishedWeeks[weekDate][i].forEach(el =>  {
                if (el[selection] !== "") blockThemes.add(el[selection])
              });
            //}

            blockThemes = Array.from(blockThemes);
            const totalColors = blockThemes.length;

            // if there is no category for the publication use default bg color
            if (blockThemes.length === 0) gradient = "#ededed";

            // set gradient for one or more colors
            blockThemes.forEach((theme, index) => {
              let color = this.themeColors[theme] ? this.themeColors[theme] : "#ededed";
              gradient += color + ' ' + Math.floor(100 / totalColors * (index)) + '%, ';
              if (index + 1 < totalColors) {
                gradient += color + ' ' + Math.floor(100 / totalColors * (index + 1)) + '%, ';
              }
              else gradient += color + ' 100%)';
            });

            b.style.background = gradient;
            b.addEventListener("click", () => {
              let publication = this.publishedWeeks[weekDate][i][0];
              ((publication) => {
                this.selectedPublication = publication;
                this.goToPublication();
              })(publication)
            }, false);
          }

          // set borders
          const border = b.parentElement;
          let boxDay = new Date(weekDate);
          (boxDay).setDate((new Date(weekDate)).getDate() + i);

          if (lastWeek) {
            border.style.borderTop = this.monthChecker(boxDay, 7) ? borderStyle : "none";
            border.style.borderRight = this.monthChecker(boxDay, 1) && i < 6 ? borderStyle : "none";
            border.style.borderBottom = this.monthChecker(boxDay, -7) ? borderStyle : "none";
          }
          else border.style.border = "none";
        });
      });
    },
    monthChecker(date, daysToAdd) {
      /**
       * Returns boolean whether the date after the added days
       * is still the same month
       */
      let checkDate = new Date(date);
      let currentMonth = checkDate.getMonth();
      checkDate.setDate((checkDate).getDate() + daysToAdd)
      let nextMonth = checkDate.getMonth();

      return currentMonth !== nextMonth;
    },
    getFirstWeekDay(date) {
      let d = new Date(date);
      let day = d.getDay(),
          diff = d.getDate() - day;
      return new Date(d.setDate(diff)).toString();
    },
    addDays(date, daysToAdd) {
      let d = new Date(date);
      d.setDate((d).getDate() + daysToAdd)
      return new Date(d).toISOString();
    },
    async downloadData() {
      this.downloadStatus = true;
      let lineArray = [
        "data:text/tsv;charset=utf-8,"];

      if (this.selectedJournalist.Publicaciones.length > 0) {
        const generalHeaders = Object.keys(this.selectedJournalist),
              publicationHeaders = Object.keys(this.selectedJournalist.Publicaciones[0]);

        let generalData = "";
        await generalHeaders.forEach((h, index) => {
          if (h == 'Publicaciones') return;
          const valueToText = Array.isArray(this.selectedJournalist[h]) ? '"' + this.selectedJournalist[h].join() + '"' : this.selectedJournalist[h];
          generalData += valueToText + '|';
        })
        lineArray[0] += generalHeaders.join('|');

        // don't download app data
        publicationHeaders.splice(publicationHeaders.indexOf("dayNumber"), 1);
        publicationHeaders.splice(publicationHeaders.indexOf("weekStart"), 1);
        publicationHeaders.splice(publicationHeaders.indexOf("month"), 1);
        publicationHeaders.splice(publicationHeaders.indexOf("index"), 1);
        lineArray[0] += publicationHeaders.join('|');

        await this.selectedJournalist.Publicaciones.forEach(publication => {
          let publicationColumns = "";
          publicationHeaders.forEach(h => {
            const valueToText = Array.isArray(publication[h]) ? publication[h].join() : publication[h];
            publicationColumns += valueToText + '|';
          })
          lineArray.push(generalData + publicationColumns);
        })
      }
      else {
        const headers = Object.keys(this.selectedJournalist);
        lineArray[0] += headers.join();
        let line = "";
        await headers.forEach((h, index) => {
          if (h == 'Publicaciones') return;
          const valueToText = Array.isArray(this.selectedJournalist[h]) ? '"' + this.selectedJournalist[h].join() + '"' : this.selectedJournalist[h];
          line += valueToText + ',';
        })
        lineArray.push(line);
      }

      let csvContent = encodeURI(lineArray.join("\n"));
      this.downloadStatus = false;
      var link = document.createElement("a");
      link.setAttribute("href", csvContent);
      link.setAttribute("download", "DefensoresDeLaDemocracia.tsv");
      document.body.appendChild(link);
      link.click();
    },
    async update() {
      await Promise.all([
        this.journalistPublications,
        this.getJournalistOptions(),
        this.getPublishedWeeks(),
        this.getPublishedMonths()
      ]);
      this.expand = true;
      this.drawMobileHeatMap(this.subjectSelected);
      this.drawHeatmap(this.subjectSelected);
    },
    async initialize() {
      this.update();
      window.onresize = () => {
        //this.drawBars();
        if (this.expand) this.drawHeatmap(this.subjectSelected);
        else this.drawBars(this.subjectSelected);
      }
    }
  },
  mounted() {
    this.initialize();
    //this.drawBars();
    //this.drawHeatmap(this.subjectSelected);
  }
}
</script>
<style lang="scss" scoped>
select {
  border: none;
  border-bottom: 1px solid #e6e6e6;
  border-radius: 0;
  width: 100%;
  color: #000;
  line-height: 1.3;
  max-width: 300px;
  &:focus {
    box-shadow: none;
    border-color: #e6e6e6;
  }
  .options {
    padding-top: 0.5rem;
  }
  option:hover {
    background-color: #e6e6e6;
  }
}
.box {
  width: 14px;
  height: 14px;
  margin: auto;
  color: #565fdd;
  background-color:lightgray;
}

.expand {
  color: #343434;
  &:hover {
    opacity: 0.7;
  }
}

.theme-label {
  max-width: 110px;
  line-height: 1.1;
  min-width: 85px;
}

select {
  font-size: 15px;
}

#heatmapcol {
  max-width: 900px;
}

.control {
  cursor: pointer;
}

#barscol {
  //transition: all 0.7s ease-out;
  min-height: 50vh;
  max-height: 70vh;
  .category {
    width: 100%;
    background: none !important;
    border: none !important;
    .bar {
      height: 25px;
      width: 100%;
      max-width: 250px;
      margin: 1px auto 0px auto;
      background-color:lightgray;
    }
  }
}

#heatmap {
  //transition: all 0.5s ease-out;
  .weeks {
    margin: 10px;
    .dateborder {
      margin-left: auto;
      margin-right: auto;
      width: 15%;
      padding-top: 0.5rem;
      .month {
        margin-left: auto;
        margin-right: auto;
        text-transform: uppercase;
      }
      .date {
        font-size: 10px;
        margin-right: 2rem;
        color: #adadad;
        span {
          font-size: 12px;
          color: #141414;
        }
      }
    }
    .borders {
      width: 10%;
      padding: 3px 3px;
      padding-top: 0.5rem;
      .blocks {
        width: 100%;
        height: 70px;
        opacity: 1;
        &:hover {
          cursor: pointer;
        }
        &.empty {
          background-color: #f7f7f7 !important;
          opacity: 0.8;
          cursor: initial !important;
        }
      }
    }
  }
}

.v-context a {
  color: #343434;
  font-size: 15px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to {//.fade-leave-active below version 2.1.8  {
  opacity: 0;
}

@media (max-width: 767.98px) {
  .box {
    margin: 0px 3px 0px 0px;
  }
  .mobile-blocks {
    width: 50px;
    height: 50px;
    background-color: #343434;
    cursor: pointer;
  }
  .allmonths {
    text-transform: capitalize;
    font-size: 1.4rem;
    p.month {
      border-bottom: 1px solid #7a7a7a;
      line-height: 0.1em;
      span {
        background:#fff;
        padding-right: 2rem;
      }
    }
  }
}
.colllor {
  color: #126aaa;
  color: #ff651f;
  color: #e72727;
  color: #ffb11f;
  color: #79232c;
  color: #309140;
  color: #6e369c;
  color: #1fadff;
  color: #1f662b;
  color: #28235e;
  color: #a13a44;
}
</style>
